import React from 'react';
import ReactDOM from 'react-dom/client';  // ✅ updated import
import { BrowserRouter } from 'react-router-dom';  // ✅ replaces Router + createBrowserHistory
import { ConfigProvider, App } from 'antd';

import './index.css';
import './assets/scss/_main-dir.scss';
import './assets/less/_main-dir.less';
import AppTsx from './App';

// ✅ React 18 createRoot API
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',   // replaces @primary-color
          borderRadius: 6,
          // all design tokens go here
        },
        components: {
          Button: {
            colorPrimary: '#1890ff', // component-level overrides
          }
        }
      }}
    >
      <App>
        <BrowserRouter>
          <AppTsx />
        </BrowserRouter>
      </App>
    </ConfigProvider>
  </React.StrictMode>
);